__webpack_require__.p = "/react-unicorn-whitelabel/";